// ─── Catalogue des feature flags ─────────────────────────────────────────────
// Source unique de vérité pour tous les flags utilisés dans l'app.
// Chaque flag a un nom, une description, et une valeur par défaut. Ces
// valeurs servent de fallback si aucune source distante n'est branchée
// (premier boot, offline, ou avant l'init du SDK GrowthBook/LaunchDarkly).
//
// Ajouter un flag : déclarer une nouvelle clé dans FEATURE_FLAGS avec son
// type et sa valeur par défaut. Le typage `keyof` propage la complétion IDE
// sur `useFeatureFlag()` automatiquement.

export const FEATURE_FLAGS = {
  /** Affiche le bouton VIP teaser sur la Home cliente. */
  vipTeaser:                  { default: true,  description: "Hero VIP sur Home" },

  /** Active le flow Diaspora (envoi de courses aux proches). */
  diasporaEnabled:            { default: true,  description: "Feature Diaspora" },

  /** Active le polling REST de secours si le WebSocket reste down >5s. */
  trackingOfflineFallback:    { default: true,  description: "Tracking polling fallback" },

  /** Cache l'affichage du solde si l'utilisateur l'a masqué (eye-toggle). */
  walletBalanceHidden:        { default: false, description: "Hide wallet balance by default" },

  /** Force le mode "Bientôt disponible" sur les écrans Wallet Recharge/Withdraw. */
  walletComingSoon:           { default: true,  description: "Wallet Recharge/Withdraw 'bientôt'" },

  /** Active la collecte breadcrumbs Sentry-style (sans envoyer si DSN absent). */
  monitoringBreadcrumbs:      { default: true,  description: "Crash reporter breadcrumbs" },

  /** Variant A/B sur l'écran Home : montre ou non la carte tracking active. */
  homeShowActiveOrderCard:    { default: true,  description: "A/B — TrackingCard sur Home" },

  /** Active les points d'entrée vers le chat support tawk.to. */
  supportChatEnabled:         { default: true,  description: "Chat support tawk.to" },
} as const;

export type FeatureFlagKey = keyof typeof FEATURE_FLAGS;

// Helper pour récupérer la valeur par défaut d'un flag (utilisé en fallback
// si une source distante n'a pas chargé).
export function defaultValue(key: FeatureFlagKey): boolean {
  return FEATURE_FLAGS[key].default;
}
